diy.angular.registerDirective('diyfmpreview', ['$timeout', 'diyfmsectionsdata', 'diyfilename', 'diyl10n', 'diyfmselectiondata', 'diyfiledownload', 'diyfmconfig',
function($timeout, diyfmsectionsdata, diyfilename, diyl10n, diyfmselectiondata, diyfiledownload, diyfmconfig) {

    var tpl = '\
        <div class="fm-preview-wrap"\
            ng-class="{\
                    \'fm-item-noname\': !item.getName(),\
                    \'fm-item-inserted\': inserted\
            }"\
            >\
            <div class="fm-preview-image">\
                <div class="fm-preview-image-wrap">\
                    <img ng-style="preview.item.getSource().getPreviewStyle(preview.item)" />\
                </div>\
                <div class="fm-preview-prev"\
                    ng-show="preview.prevItem"\
                    ng-click="showPreview(preview.prevItem, false)"><div class="ui-icon"></div></div>\
                <div class="fm-preview-next"\
                    ng-show="preview.nextItem"\
                    ng-click="showPreview(preview.nextItem, false)"><div class="ui-icon"></div></div>\
                <div ng-hide="diyfmconfig.isInManagementMode() || actions.length > 0" \
                    class="fm-preview-add" ng-click="toggleInsert(preview.item, \'preview\')">{{addLabel}}</div>\
            </div>\
            <div class="fm-preview-sidebar" ng-show="actions.length > 0">\
                <div class="fm-preview-name-section">\
                    <div class="fm-preview-name" ng-bind="preview.item.getName()"\
                        diyfminlineedit="nameEditConfig"\
                        ></div>\
                </div>\
                <div class="fm-preview-actions">\
                    <div class="fm-preview-action"\
                        ng-repeat="_action in actions"\
                        ng-init="buttonConfig = {icons: {primary: \'ui-icon-\' + _action.icon}, label: _action.title}"\
                        >\
                        <button \
                            diybutton="buttonConfig" \
                            class="ui-button-borderless"\
                            ng-click="actionClick(_action)"\
                                ></button>\
                    </div>\
                </div>\
                <div ng-hide="diyfmconfig.isInManagementMode()" class="fm-preview-add" ng-click="toggleInsert(preview.item, \'preview\')">{{addLabel}}</div>\
            </div>\
            <div class="ui-icon ui-icon-close" ng-click="hidePreview(true, true)"></div>\
        </div>';

    return {
        template: tpl,
        scope: true,
        link: function(scope, elem, attr) {

            var 
                $elem = jQuery(elem),
                $img = $elem.find('.fm-preview-image img')
            ;

            scope.diyfmconfig = diyfmconfig;

            // TODO this is done to prevent dragging of the preview image, though in the future it would be nice to be able to drag it as well
            $img.bind('dragstart', function (e) {e.preventDefault();});
            
            scope.nameEditConfig = {
                textarea: true,
                end: function(value) {
                    scope.renameItem(scope.preview.item, value);
                }
            };
            
            scope.addLabel = diyl10n('filemanager.preview.addFile');

            scope.actionClick = function(action) {
                switch(action.name) {
                    case 'rename':
                        var parsedName = diyfilename.parse(scope.preview.item.getName());
                        scope.nameEditConfig.start(parsedName.name);
                        break;
                    case 'delete':
                        scope.deleteItem(scope.preview.item);
                        break;
                    case 'download':
                        diyfiledownload(scope.preview.item.getFile());
                        break;
                    default:
                        break;
                }
            };
            
            scope.actions = [];

            scope.$watch(diyfmsectionsdata.getCurrentSubsection, function(newSubsection) {
                if (newSubsection) {
                    var actions = [];
                    actions.length = 0;

                    newSubsection.getItemActions().forEach(function(action) {
                        if (action.name !== 'preview') {
                            actions.push(action);
                        }
                    });

                    scope.actions = actions;
                }
            });

            scope.$watch('preview.item', function(newPreviewItem){
                if (newPreviewItem) {
                    // quickly replace it with a blank gif
                    // so that if loading preview image will take a while
                    // old preview image will not be shown instead
                    // we leave 10ms to allow the browser to start loading the blank image,
                    // if it doesn't have enough time it will skip the blank and negate its purpose
                    $img.attr('src', 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7');
                    $timeout(function(){
                        $img.attr('src', newPreviewItem.getPreview());
                    }, 10);

                    updateInsertedState();
                }
            });

            var updateInsertedState = function() {
                scope.inserted = diyfmselectiondata.isItemInserted(scope.preview.item);
                if (scope.inserted) {
                    scope.addLabel = diyl10n('filemanager.preview.fileAdded');
                } else {
                    scope.addLabel = diyl10n('filemanager.preview.addFile');
                }
            }

            scope.$watch(diyfmselectiondata.getSelectionStateNumber, function(newValue, oldValue) {
                if (scope.preview.item) {
                    updateInsertedState();
                }
            });
        }
    };
}]);




/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/directives/diyfmpreview.js
 ** module id = 978
 ** module chunks = 0
 **/